import { render, staticRenderFns } from "./Pinner.vue?vue&type=template&id=9869ea24&"
import script from "./Pinner.vue?vue&type=script&lang=js&"
export * from "./Pinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports